import { connect } from 'react-redux'
import { compose, withState, lifecycle } from 'recompose'
import { setIsTrailer } from 'components/QuickAppointmentPage/actions'

const withStepState = withState('currentStepIndex', 'setCurrentStepIndex', 0)

const withLoadingState = withState('isLoading', 'setIsLoading', false)

const withDateTimeData = withState(
  'appointmentDetailsResponseVO',
  'setAppointmentDetailsResponseVO',
  {
    appointmentDateAndSlotsVO: []
  })

const withLifecycle = lifecycle({
  componentDidMount() {
    const { setIsTrailer } = this.props
    setIsTrailer(false)
  },
  componentDidUpdate({ currentStepIndex: prevCurrentStepIndex, appointmentResponse: prevAppointmentResponse }) {
    const { currentStepIndex, appointmentResponse } = this.props

    if ((currentStepIndex !== prevCurrentStepIndex) ||
      (prevAppointmentResponse !== appointmentResponse && appointmentResponse)) {
      window.scrollTo(0, 0)
    }
  }
})

export default compose(
  connect(null, { setIsTrailer }),
  withStepState,
  withLoadingState,
  withDateTimeData,
  withLifecycle
)
